import { faClockRotateLeft } from "@fortawesome/pro-light-svg-icons/faClockRotateLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, Grid, Typography } from "@mui/material";
import { MprcIconButton } from "components";
import { useMprcTheme } from "components/MprcThemeProvider";
import { MprcUserProfileLink } from "components/MprcUserProfileLink";
import { RecordInfoDto } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import React from "react";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    recordInfo?: RecordInfoDto;
    variant?: "viewAll" | "createOnly" | "modifyOnly" | "deleteOnly";

    /**
     * Texto para criador.
     */
    createByText?: string;

    /**
     * Texto para revisor.
     * Se NULO a linha de revisão não será exibida.
     */
    revisedByText?: string | null;

    onHistoryClick?: () => void;
    children?: React.ReactNode;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Edição de Papéis de Segurança
 * @param props
 */
export const MprcRecordInfo: React.FC<IProps> = ({ children, recordInfo, createByText, revisedByText, variant = "viewAll", onHistoryClick }) => {
    ////////////////////////////////////////////////////////////////////////////

    const { theme } = useMprcTheme();

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    const av = revisedByText === null ? recordInfo?.creator : recordInfo?.revisor;

    return (
        <>
            {
                recordInfo &&
                <Grid container alignItems="flex-start" spacing={2}>

                    <Grid title={av!.name}>
                        <Avatar variant="circular" src={av!.thumbnailUrl} sx={{ width: 48, height: 48 }} />
                    </Grid>

                    <Grid size="grow">

                        {
                            (variant == "viewAll" || variant == "createOnly") &&
                            <Typography component="p" variant="subtitle1">
                                {createByText ?? theme.MprcRecordInfo.createdBy} <b><MprcUserProfileLink user={recordInfo.creator} /></b> {Formaters.relativeTime(recordInfo.creator.occurrenceDate)}
                            </Typography>
                        }

                        {
                            revisedByText === undefined && ((variant == "viewAll" && recordInfo.creator.occurrenceDate.getTime() != recordInfo.revisor.occurrenceDate.getTime()) || variant == "modifyOnly") &&
                            <Typography component="p" variant="subtitle1">
                                {theme.MprcRecordInfo.changedBy} <b><MprcUserProfileLink user={recordInfo.revisor} /></b> {Formaters.relativeTime(recordInfo.revisor.occurrenceDate)}
                            </Typography>
                        }

                        {
                            revisedByText &&
                            <Typography component="p" variant="subtitle1">
                                {revisedByText} <b><MprcUserProfileLink user={recordInfo.revisor} /></b> {Formaters.relativeTime(recordInfo.revisor.occurrenceDate)}
                            </Typography>
                        }

                        {
                            recordInfo.deleter && (variant == "viewAll" || variant == "deleteOnly") &&
                            <Typography component="p" variant="subtitle1">
                                {theme.MprcRecordInfo.deletedBy} <b><MprcUserProfileLink user={recordInfo.deleter!} /></b> {Formaters.relativeTime(recordInfo.deleter?.occurrenceDate)}
                            </Typography>
                        }

                        {children}
                    </Grid>

                    <Grid>
                        {
                            onHistoryClick &&
                            <Typography variant="body2" sx={{ textAlign: "center" }}>
                                <MprcIconButton color="inherit" onClick={onHistoryClick}>
                                    <FontAwesomeIcon icon={faClockRotateLeft} fixedWidth size="2x" />
                                </MprcIconButton>
                                <br />
                                {theme.MprcRecordInfo.historyText}
                            </Typography>
                        }
                    </Grid>
                </Grid >
            }
        </>
    );
};
